import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { MerchCardShadowColumns } from 'pricing-pages-ui-components/components/MerchCardShadowColumns';
import { getMerchCardsToShow } from '../../../constants/merchCards/MerchCardsToShow';
import { SCREENS } from '../../../constants/tracking/Screens';
import { SUITE_CARD } from '../../../constants/tracking/TrackingSources';
import { useAppSelector } from '../../../reducers';
import { isUngatedForInbound25Selector } from '../../../selectors/GatingSelectors';
import { FreeCard } from '../cards/FreeCard';
import { StandardSuiteCard } from '../cards/suite/StandardSuiteCard';

// This is used as the merch cards for the customer platform routes
import { jsx as _jsx } from "react/jsx-runtime";
export const SuitePageCardContainer = ({
  selectedTab
}) => {
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  const productLevelsToShow = getMerchCardsToShow({
    tab: selectedTab
  });
  const suiteCardComponents = productLevelsToShow.map((productLevel, index) => {
    if ('FREE' === productLevel) {
      return /*#__PURE__*/_jsx(FreeCard, {
        productLine: "crm",
        columnStart: index + 1,
        trackingSource: SUITE_CARD
      }, productLevel);
    }
    return /*#__PURE__*/_jsx(StandardSuiteCard, {
      productLevel: productLevel,
      screen: SCREENS.SUITE,
      columnStart: index + 1
    }, productLevel);
  });
  const columns = productLevelsToShow.length;
  return /*#__PURE__*/_jsx(PageSection, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsx(MerchCardShadowColumns, {
      columns: columns,
      isUngatedForInbound25: isUngatedForInbound25,
      children: suiteCardComponents
    })
  });
};